import { z } from "zod";
import { zKlusSoort } from "@personeel/gen/hey-api/zod.gen";

export const KlusSoortSchema = zKlusSoort.strip();

export type KlusSoortModel = z.infer<typeof KlusSoortSchema>;

export const KlusSoortenModelSchema = z.array(KlusSoortSchema);

export type KlusSoortenModel = z.infer<typeof KlusSoortenModelSchema>;
